import React, { useState, useEffect } from "react";
import { LogEntry, apiService } from "../services/api";

interface LogsProps {
  logs: LogEntry[];
  loading: boolean;
}

export const Logs: React.FC<LogsProps> = ({ logs: initialLogs, loading }) => {
  const [errorFiles, setErrorFiles] = useState<Array<{ fileName: string; content: string }>>([]);
  const [loadingErrors, setLoadingErrors] = useState(false);
  const [selectedError, setSelectedError] = useState<{ fileName: string; content: string } | null>(null);
  const [search, setSearch] = useState("");

  const loadErrorFiles = async () => {
    try {
      setLoadingErrors(true);
      const data = await apiService.getErrors();
      setErrorFiles(data.errors || []);
    } catch {
      setErrorFiles([]);
    } finally {
      setLoadingErrors(false);
    }
  };

  useEffect(() => {
    loadErrorFiles();
  }, []);

  if (loading && loadingErrors) {
    return <div className="loading">Caricamento log di sistema...</div>;
  }

  const filteredErrors = errorFiles.filter(
    (e) =>
      e.fileName.toLowerCase().includes(search.toLowerCase()) ||
      e.content.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="tab-content">
      <div className="card-header-row">
        <div>
          <h2>Log di Errore & Diagnostica</h2>
          <p className="subtitle">Tracciamento eccezioni e file di crash registrati dal bot</p>
        </div>
        <button onClick={loadErrorFiles} className="btn secondary-btn">
          🔄 Ricarica Log
        </button>
      </div>

      <div className="filter-bar">
        <input
          type="text"
          placeholder="🔍 Cerca nei log o nel messaggio di errore..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="search-input"
        />
      </div>

      {filteredErrors.length === 0 ? (
        <div className="empty-state">
          <div className="empty-icon">✅</div>
          <h3>Nessun Errore Rilevato</h3>
          <p>Il bot è in esecuzione senza crash recenti o errori non gestiti.</p>
        </div>
      ) : (
        <div className="logs-layout">
          <div className="logs-sidebar-list">
            {filteredErrors.map((err) => (
              <div
                key={err.fileName}
                className={`log-item-card ${selectedError?.fileName === err.fileName ? "active" : ""}`}
                onClick={() => setSelectedError(err)}
              >
                <div className="log-item-header">
                  <span className="error-tag">ERRORE</span>
                  <span className="log-date">{err.fileName.replace(".txt", "").replace(/T/, " ")}</span>
                </div>
                <div className="log-preview-text">
                  {err.content.split("\n")[0] || "Errore sconosciuto"}
                </div>
              </div>
            ))}
          </div>

          <div className="log-detail-viewer">
            {selectedError ? (
              <div className="card log-viewer-card">
                <div className="log-viewer-header">
                  <h4>File: {selectedError.fileName}</h4>
                  <button
                    onClick={() => {
                      navigator.clipboard.writeText(selectedError.content);
                      alert("Log copiato negli appunti!");
                    }}
                    className="btn secondary-btn small-btn"
                  >
                    📋 Copia Stack
                  </button>
                </div>
                <pre className="stacktrace-box">{selectedError.content}</pre>
              </div>
            ) : (
              <div className="card log-viewer-placeholder">
                <p>👈 Seleziona un file di log dalla lista per esaminare lo stack trace completo</p>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};
